import { SnowflakeMeltIcon } from './SnowflakeMeltIcon';

/**
 * author: Michael Irigoyen
 * id 017BAEB6-E5B4-4BEF-8CA3-D0ABA689DE2C
 * name snowflake-melt
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snowflake-melt.svg
 * tags
 * - Weather 
 */
export const DefrostIcon = SnowflakeMeltIcon;
export default DefrostIcon